import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row, Card, CardBody} from 'reactstrap';
import withAuth from '../../../../components/Services/WithAuth';
import './style.css';
import OverridingRiskForm from './Automated Overrinding Form/index';
import { createAutomatedOverriddingRiskFactor, automatedOveriddingRiskFactorDetails, editAutomatedOverriddingRiskFactor } from './action';
import AutomatedOverriddingRiskModal from '../../../../components/ReusableComponents/ModalComponent/AutomatedOverriddingRiskModal/index'
import { validateOverriddingRisk, createOverriddingRiskRequestBody } from './helper'
class CreateAutomatedOverridingRiskFactor extends Component {
    constructor() {
        super();
        this.state = {
            pageType: null,
            overriddingInitialValue: {
                overriddingRiskFactorName: '',
                overriddingScore: '',
                overriddingRule: '',
                overriddingFactors: ''
            },
            validateOveriddingFactorFlag: true,
            overiddingId: null,
            createAutomatedOverriddingRiskFactorSuccess:null
        }
    }
    componentDidMount() {
        this.setState({
            overiddingId: this.props.match.params.overriddingId
        }, () => {
            this.props.automatedOveriddingRiskFactorDetails(this.state.overiddingId);
        })
    }
    componentDidUpdate(prevProps) {
        const { automatedOverriddingRiskFactor, automatedOverriddingRiskFactorDetails } = this.props
        if (automatedOverriddingRiskFactor !== prevProps.automatedOverriddingRiskFactor) {
            this.setState({
                validateOveriddingFactorFlag: !validateOverriddingRisk(this.props.automatedOverriddingRiskFactor.values)
            })
        }
        if (automatedOverriddingRiskFactorDetails !== prevProps.automatedOverriddingRiskFactorDetails) {
            this.setState({
                overriddingInitialValue: {
                    overriddingRiskFactorName: automatedOverriddingRiskFactorDetails.data.name,
                    overriddingScore: automatedOverriddingRiskFactorDetails.data.score,
                    overriddingFactors: automatedOverriddingRiskFactorDetails.data.factors,
                    overriddingRule: automatedOverriddingRiskFactorDetails.data.rule,
                    isAutomated: automatedOverriddingRiskFactorDetails.data.isAutomated
                }
            })
        }
        
    }
    handleSave = () => {
        
        const requestBody = createOverriddingRiskRequestBody(this.props.automatedOverriddingRiskFactor)
        if (!this.state.overiddingId) {
            this.props.createAutomatedOverriddingRiskFactor(requestBody);
        } else {
            this.props.editAutomatedOverriddingRiskFactor(requestBody, this.state.overiddingId);
        }

    }
    handleCancel = () => {
        this.props.history.push('../list');
    }
    modalCallBack = () => {
        if(!this.state.overiddingId){
            this.props.history.push('./../list');
        } else {
            this.props.history.push('./../../list');
        }
        
    }
    render() {
        return (
            <Col>
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">{this.state.pageType} Overridding Risk Factor</h4>
                        </div>
                        <Card>
                            <CardBody>
                                <OverridingRiskForm initialValues={this.state.overriddingInitialValue} />
                                <Row>
                                    <Col sm="14" className="text-right">
                                        <Button outline color="primary" title="Cancel" onClick={this.handleCancel}>
                                            Cancel
                                        </Button>
                                        <Button className="ml-3" color="primary" onClick={this.handleSave} disabled={this.state.validateOveriddingFactorFlag} title="Save Overridding Risk">
                                            Save
                                        </Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <AutomatedOverriddingRiskModal modalCallBack={this.modalCallBack} />
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    automatedOverriddingRiskFactor: state.form.automatedOverriddingForm,
    automatedOverriddingRiskFactorDetails: state.automatedOverriddingRiskFactor.automatedOverriddingRiskFactorDetails
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    createAutomatedOverriddingRiskFactor: (requestBody) => { dispatch(createAutomatedOverriddingRiskFactor(requestBody)) },
    automatedOveriddingRiskFactorDetails: (id) => { dispatch(automatedOveriddingRiskFactorDetails(id)) },
    editAutomatedOverriddingRiskFactor: (requestBody, id) => { dispatch(editAutomatedOverriddingRiskFactor({ requestBody: requestBody, id: id })) }
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(CreateAutomatedOverridingRiskFactor));
